import {
  Download as NewIconDownload,
  ChevronBack as NewIconChevron,
  Checkmark as NewIconCheckmark,
  ShareIos as NewIconShareIos,
  IntegratedSolutions as NewIconLinkExternal,
  HeartFilled as NewIconHeartFilled,
  MinusCircle as NewIconMinusCircleFilled,
  Plus as NewIconPlus,
  CloudSave as NewIconCloudSave,
  Edit as NewIconEdit,
  Cancel as NewIconCancel,
  ResetClear as NewIconBhResetClear,
  Information as NewIconInformation,
  Document as NewIconDocument,
  Departed as NewIconDepartedVariant,
  Minus as NewIconMinus,
  Filter as NewIconFilter,
  GlobalForwardingFreight as NewIconOceanFreight,
  TruckRoadFreight as NewIconRoadFreight,
  PlaneAirFreight as NewIconAirFreight,
  Parcel as NewIconParcel,
  IlluParcelDocuments as NewIconIlluParcelDocuments,
  IlluFreightShipping as NewIconIlluFreightShipping,
  IlluTwoDocuments as NewIconIlluTwoDocuments,
  Upload as NewIconUpload,
  TrashBinDelete as NewIconTrashbin,
  IlluMovingBox as NewIconIlluMovingBox,
  IlluTrackPackage as NewIconIlluTrackPackage,
  ChevronForward as NewIconChevronForward,
  Sort as NewIconSort,
  Settings as NewIconSettings,
} from "@dhl-official/icons";

import React from "react";

export const IconArrow = (props) => {
  return <NewIconChevronForward {...props} />;
};

export const IconSettings = (props) => {
  return <NewIconSettings {...props} />;
};

/**
 * Migration wrapper for IconDownload component
 */
export const IconDownload = (props) => {
  return <NewIconDownload {...props} />;
};

/**
 * Migration wrapper for IconChevron component
 */
export const IconChevron = (props) => {
  return <NewIconChevron {...props} />;
};

/**
 * Migration wrapper for IconHeartFilled component
 */
export const IconHeartFilled = (props) => {
  return <NewIconHeartFilled {...props} />;
};

/**
 * Migration wrapper for IconCircleFilled component
 */
export const IconMinusCircleFilled = (props) => {
  return <NewIconMinusCircleFilled {...props} />;
};

/**
 * Migration wrapper for IconPlus component
 */
export const IconPlus = (props) => {
  return <NewIconPlus {...props} />;
};

/**
 * Migration wrapper for IconCloudSave component
 */
export const IconCloudSave = (props) => {
  return <NewIconCloudSave {...props} />;
};

/**
 * Migration wrapper for IconEdit component
 */
export const IconEdit = (props) => {
  return <NewIconEdit {...props} />;
};

/**
 * Migration wrapper for IconCancel component
 */
export const IconCancel = (props) => {
  return <NewIconCancel {...props} />;
};

/**
 * Migration wrapper for IconShareIos component
 */
export const IconShareIos = (props) => {
  return <NewIconShareIos {...props} />;
};

/**
 * Migration wrapper for IconBhResetClear component
 */
export const IconBhResetClear = (props) => {
  return <NewIconBhResetClear {...props} />;
};

/**
 * Migration wrapper for IconCheckmark component
 */
export const IconCheckmark = (props) => {
  return <NewIconCheckmark {...props} />;
};

/**
 * Migration wrapper for IconLinkExternal component
 */
export const IconLinkExternal = (props) => {
  return <NewIconLinkExternal {...props} />;
};

/**
 * Migration wrapper for IconInformation component
 */
export const IconInformation = (props) => {
  return <NewIconInformation {...props} />;
};

/**
 * Migration wrapper for IconDocument component
 */
export const IconDocument = (props) => {
  return <NewIconDocument {...props} />;
};

/**
 * Migration wrapper for IconDepartedVariant component
 */
export const IconDepartedVariant = (props) => {
  return <NewIconDepartedVariant {...props} />;
};

/**
 * Migration wrapper for IconMinus component
 */
export const IconMinus = (props) => {
  return <NewIconMinus {...props} />;
};

/**
 * Migration wrapper for IconFilter component
 */
export const IconFilter = (props) => {
  return <NewIconFilter {...props} />;
};

/**
 * Migration wrapper for IconOceanFreight component
 */
export const IconOceanFreight = (props) => {
  return <NewIconOceanFreight {...props} />;
};

/**
 * Migration wrapper for IconIlluOceanFreight component
 */
export const IconRoadFreight = (props) => {
  return <NewIconRoadFreight {...props} />;
};

export const IconAirFreight = (props) => {
  return <NewIconAirFreight {...props} />;
};

export const IconParcel = (props) => {
  return <NewIconParcel {...props} />;
};

export const IlluParcelDocuments = (props) => {
  return <NewIconIlluParcelDocuments {...props} />;
};

export const IlluFreightShipping = (props) => {
  return <NewIconIlluFreightShipping {...props} />;
};

export const IlluTwoDocuments = (props) => {
  return <NewIconIlluTwoDocuments {...props} />;
};

export const IconDeparted = (props) => {
  return <NewIconDepartedVariant {...props} />;
};

export const IconUpload = (props) => {
  return <NewIconUpload {...props} />;
};

export const IconTrashbin = (props) => {
  return <NewIconTrashbin {...props} />;
};

export const IlluMovingBox = (props) => {
  return <NewIconIlluMovingBox {...props} />;
};

export const IlluTrackPackage = (props) => {
  return <NewIconIlluTrackPackage {...props} />;
};

export const IconChevronForward = (props) => {
  return <NewIconChevronForward {...props} />;
};

export const IconSort = (props) => {
  return <NewIconSort {...props} />;
};

export default {
  IconDownload,
  IconChevron,
  IconShareIos,
  IconHeartFilled,
  IconMinusCircleFilled,
  IconPlus,
  IconBhResetClear,
};
